
import axios from '.';

export default {
    getShowcase,
    deleteShowcase,
    deleteAllShowcase,
    createShowcase,
    getShowcaseByUserId,
    visibilityShowcase,
    visibilityRequestShowcase,
    visibilityApprovedShowcase,
    visibilityDeclineShowcase
};

async function createShowcase(data, config) {
    let formData = new FormData();
    if (data.files || data.files.length) {
        data.files.forEach((v, i) => {
            formData.append(`file${i}`, v.file);
            
        });
        if (data.visibility && data.visibility.length) {
            data.visibility.forEach((visibilityStatus, index) => {
                formData.append(`visibility-${index}`, visibilityStatus);
            });
        }
    }
    try {
        const response = await axios.post('/api/showcase', formData, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

async function getShowcase(data) {
    const urlStr = '/api/showcase'
    const response = await axios.get(urlStr);
    return response.data;
}

async function getShowcaseByUserId(data) {
    const urlStr = `/api/showcase/user/${data}`
    const response = await axios.get(urlStr);
    return response.data;
}


async function deleteShowcase(id) {
    const response = await axios.delete('/api/showcase/' + id);
    return response.data;
}


async function visibilityShowcase(params,data) {
    const response = await axios.put(`/api/showcase/${params.showcase_id}`, data);
    return response.data;
}


async function visibilityRequestShowcase(data) {
    const response = await axios.post(`/api/showcase/request`, data);
    return response.data;
}

async function visibilityApprovedShowcase(data) {
    const response = await axios.post(`/api/showcase/approve_request`, data);
    return response.data;
}

async function visibilityDeclineShowcase(data) {
    const response = await axios.post(`/api/showcase/decline_request`, data);
    return response.data;
}
async function
 deleteAllShowcase(data) {
    const response = await axios.delete('/api/showcase/all');
    return response.data;
}
